import { render, staticRenderFns } from "./SparklBankStandaloneView.vue?vue&type=template&id=78b5d589"
import script from "./SparklBankStandaloneView.vue?vue&type=script&lang=js"
export * from "./SparklBankStandaloneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports